export const toLinearString = (number) => {
    if(!number) return ""
    
    if (Math.abs(number) < 1.0 && number.toString().includes('e-')) {
      var decimal = parseInt(number.toString().split('e-')[1]);
      return number.toFixed(decimal+1)
    }
    return number;
}
